export default "__VITE_ASSET__DNXxsiTk__"